import React, { useEffect, useState, useRef } from 'react'
import {
    awaitDelay, charactersRemainingGet, getError, getLanguageObj, getResponse, isUndNullEmpNew, isUndNullNew, LoadingSection, sendMessageCloseCurrentWindow, settings, validateTextIsHTML
} from '../../helpers/UtilsHelper';
import HtmlParser from 'react-html-parser';
import BotEmojis from './BotEmojis';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useAuth from '../../auth/useAuth';
import Menu from '../main/Menu';
import { PromptClass } from '../../classes/ai/promptClass';
import { UserClass } from '../../classes/user/userClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { PromptService } from '../../services/artificialIntelligence/PromptService';
import { UserService } from '../../services/users/UserService';

const $ = window.$;

const { app, dualListBox, firebase, labels, icons, images, messages, mercadoLibre, summerNote, } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, operators: dbOperators, } = firebase?.firestore;
const { urls } = app?.backend;

const currentMethod = 'ArtificialIntelligenceEdit - function';

export default function ArtificialIntelligenceEdit({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const { id, } = useParams();
    const auth = useAuth();
    const inputOrder = {
        max: 3,
        min: 1,
    }
    let dataObj = {};
    const rowsLength = 7;
    const chkBoStatusId = 'chkBoStatus';
    const chkBoGetContextId = 'chkBoGetContext';

    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
        back: false,
    });

    const [errors, setErrors] = useState({
        name: '',
        order: '',
        event: '',
        module: '',
        message: '',
    });

    const isMount = useRef(true);
    const [charactersRemaining, setCharactersRemaining] = useState('');
    const [botEmojisShowModal, setBotEmojisShowModal] = useState(false);
    const [textAreasShow, setTextAreasShow] = useState({ textAreaOne: false, textAreaTwo: false });
    //#endregion variables

    //#region prompt
    const [prompt, setPrompt] = useState(PromptClass?.getClass());
    const [events, setEvents] = useState([]);
    const textAreaAnswerId = 'textAreaAnswer';
    const [modules, setModules] = useState([]);
    const [moduleEvents, setModuleEvents] = useState([]);
    //#endregion prompt

    //#region methods
    //#region prompt
    const getPrompt = async ({
        id = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getPrompt';
        let response = getResponse({ type: 0 });
        try {
            response = await PromptService.getById({
                id: id,
                token: auth?.account?.tokenVzLaML?.token,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return response;

            const prompt_ = response?.result?.prompt || {};
            const modules_ = response?.result?.modules || [];
            setModules(modules_);
            const events_ = response?.result?.events || [];
            setEvents(events_);
            setModuleEvents(events_?.filter(({ moduleId, }) => moduleId === prompt_?.moduleId));
            setPrompt(prompt_);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const editPrompt = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editPrompt';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = await checkFormValue({ type: 1, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            response = await PromptService.update({
                id: prompt?.id,
                token: auth?.account?.tokenVzLaML?.token,
                data: prompt,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            const prompt_ = response?.result?.prompt || {};
            const modules_ = response?.result?.modules || [];
            setModules(modules_);
            const events_ = response?.result?.events || [];
            setEvents(events_);
            setModuleEvents(events_?.filter(({ moduleId, }) => moduleId === prompt_?.moduleId));
            setPrompt(prompt_);

            response = getResponse({
                type: 0,
                msgText_: `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`,
            });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion prompt

    //#region users
    const getUsersByAccountId = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getUsersByAccountId';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            dataObj = {
                conditionals: [
                    { field: dbFields?.userId, operator: dbOperators?.equal, value: auth?.account?.uid, },
                ],
                ordersBy: [
                    { field: dbFields?.userName, value: dbOrdersBy?.asc, },
                ]
            };

            response = await UserService.getUsers({
                token: auth?.account?.tokenVzLaML?.token,
                data: dataObj,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return response;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
    //#endregion users

    //#region others
    const processSummerNote = async ({
        e = {},
        type = 0,
        value = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'processSummerNote';
        let response = getResponse({ type: 0 });
        try {
            switch (type) {
                case -1:
                    $(`#${summerNote?.btnEvents?.destroy}`).trigger('click');
                    break;
                case 0:
                    $(`#${summerNote?.btnEvents?.reset}`).trigger('click');
                    break;
                case 1:
                    $(`#${summerNote?.btnEvents?.init}`).trigger('click');
                    break;
                case 2:
                    $(`#${summerNote?.btnEvents?.code}`).trigger('click');
                    break;
                case 3:
                    $(`#${summerNote?.btnEvents?.isEmpty}`).trigger('click');
                    break;
                case 4:
                    $(`#${mercadoLibre?.objects?.html?.bots?.messageHideId}`).val(value);
                    $(`#${summerNote?.btnEvents?.setCode}`).trigger('click');
                    break;
                default:
                    $(`#${summerNote?.btnEvents?.destroy}`).trigger('click');
                    break
            }
            if (!isUndNullEmpNew({ data: e, subMethod: currentMethod })?.result) {
                e?.preventDefault();
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }

        return response;
    }

    const processDualListBox = async ({
        e = {},
        type = 0,
        value = '',
        selected = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'processDualListBox';
        let response = getResponse({ type: 0 });
        try {
            switch (type) {
                case -1:
                    $(`#${dualListBox?.btnEvents?.destroy}`).trigger('click');
                    break;
                case 0:
                    $(`#${dualListBox?.btnEvents?.refresh}`).trigger('click');
                    break;
                case 1: {
                    const dlbLabels = dualListBox?.labels;
                    const langId = languageObj?.id || 'es';
                    const customProps = {
                        nonSelectedListLabel: dlbLabels?.nonSelectedListLabel?.[langId] || 'No asignadas',
                        selectedListLabel: dlbLabels?.selectedListLabel?.[langId] || 'Asignadas',
                        filterPlaceHolder: dlbLabels?.filterPlaceHolder?.[langId] || 'Filtrar...',
                        filterTextClear: dlbLabels?.filterTextClear?.[langId] || 'Mostrar todos',
                        infoText: dlbLabels?.infoText?.[langId] || 'Mostrando todos ({0})',
                        infoTextFiltered: dlbLabels?.infoTextFiltered?.[langId] || '<span class="badge badge-warning">Filtrados</span> {0} de {1}',
                        infoTextEmpty: dlbLabels?.infoTextEmpty?.[langId] || 'Lista vacía',
                        moveSelectedLabel: dlbLabels?.moveSelectedLabel?.[langId] || 'Mover seleccionado',
                        moveAllLabel: dlbLabels?.moveAllLabel?.[langId] || 'Mover todos',
                        removeSelectedLabel: dlbLabels?.removeSelectedLabel?.[langId] || 'Quitar seleccionado',
                        removeAllLabel: dlbLabels?.removeAllLabel?.[langId] || 'Quitar todos',
                    };
                    $(`#${dualListBox?.btnEvents?.init}`).val(JSON.stringify(customProps));
                    $(`#${dualListBox?.btnEvents?.init}`).trigger('click');
                    $(`#${dualListBox?.btnEvents?.init}`).val('');
                    break;
                }
                case 2:
                    response.result = $(`#${mercadoLibre?.objects?.html?.bots?.duallistboxId}`).val();
                    break;
                case 3:
                    $(`#${dualListBox?.btnEvents?.setValue}`).val(`{"id": "${value}", "selected": ${selected}}`);
                    $(`#${dualListBox?.btnEvents?.setValue}`).trigger('click');
                    break;
                default:
                    $(`#${dualListBox?.btnEvents?.destroy}`).trigger('click');
                    break
            }

            if (!isUndNullNew({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }

        return response;
    }

    const checkFormValue = async ({
        type = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'checkFormValue';
        let response = getResponse({ type: 0 });
        try {
            let responseOne = getResponse({ type: 0 });
            let responseTwo = getResponse({ type: 0 });

            responseOne = await processDualListBox({ e: null, type: 2, value: '', selected: false, subMethod: currentMethod });
            if (!responseOne.isSuccess || responseOne.isWarning) return responseOne;

            responseOne.result = (!isUndNullEmpNew({ data: responseOne?.result, subMethod: currentMethod })?.result && responseOne?.result?.length > 0 ? responseOne?.result : []);
            responseOne = await setFormData({ e: null, type: 'accounts', value: responseOne?.result, subMethod: currentMethod });
            if (!responseOne.isSuccess || responseOne.isWarning) return responseOne;

            if (isUndNullEmpNew({ data: prompt?.name, subMethod: currentMethod, })?.result) {
                setErrors(prev => ({ ...prev, name: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: prompt?.moduleId, subMethod: currentMethod, })?.result) {
                setErrors(prev => ({ ...prev, module: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: prompt?.eventId, subMethod: currentMethod, })?.result) {
                setErrors(prev => ({ ...prev, event: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }

            if (type === 1) {
                if (isUndNullNew({ data: prompt?.order, subMethod: currentMethod, })?.result || prompt.order <= 0) {
                    setErrors(prev => ({ ...prev, order: messages?.thisFieldRequired?.[languageObj?.id] }));
                    response = getResponse({ type: 1 });
                }

                if (textAreasShow.textAreaOne && !textAreasShow.textAreaTwo) {
                    responseTwo = await processSummerNote({ e: null, type: 2, subMethod: currentMethod });
                    if (!responseTwo.isSuccess || responseTwo.isWarning) return responseTwo;

                    responseTwo = await processSummerNote({ e: null, type: 3, subMethod: currentMethod });
                    if (!responseTwo.isSuccess || responseTwo.isWarning) return responseTwo;

                    if ($(`#${summerNote?.btnEvents?.isEmpty}`).val() === 'true') {
                        setErrors(prev => ({ ...prev, message: messages?.thisFieldRequired?.[languageObj?.id] }));
                        response = getResponse({ type: 1 });
                    }

                    const messageHideInnerTextObjLocal = $(`#${mercadoLibre?.objects?.html?.bots?.messageHideInnerTextId}`);
                    if (messageHideInnerTextObjLocal.val().length > mercadoLibre?.methods?.postSales?.seller?.maxLength) {
                        setErrors(prev => ({ ...prev, message: `${messages?.allowedCharacters?.[languageObj?.id]}: <b>${mercadoLibre?.methods?.postSales?.seller?.maxLength}</b>` }));
                        response = getResponse({ type: 1 });
                    }
                }

                if (!textAreasShow.textAreaOne && textAreasShow.textAreaTwo) {
                    if (isUndNullEmpNew({ data: prompt?.message, subMethod: currentMethod, })?.result) {
                        setErrors(prev => ({ ...prev, message: messages?.thisFieldRequired?.[languageObj?.id] }));
                        response = getResponse({ type: 1 });
                    } else if (prompt?.message?.length > mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength) {
                        setErrors(prev => ({ ...prev, message: `${messages?.allowedCharacters?.[languageObj?.id]}: <b>${mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength}</b>` }));
                        response = getResponse({ type: 1 });
                    } else {
                        responseTwo = validateTextIsHTML({ text: prompt.message, subMethod: currentMethod });
                        if (!responseTwo.isSuccess || responseTwo.isWarning) return responseTwo;

                        if (!mercadoLibre?.methods?.questionsAnswers?.answers?.htmlFormat && responseTwo.result) {
                            setErrors(prev => ({ ...prev, message: `${messages?.onlyPlainTextIsAllowed?.[languageObj?.id]}` }));
                            response = getResponse({ type: 1 });
                        }
                    }
                }
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setFormData = async ({
        e = {},
        type = '',
        value = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setFormData';
        let response = getResponse({ type: 0 });
        try {
            const setFormData_ = prompt;
            switch (type) {
                case 'order':
                    setPrompt(prev => ({
                        ...prev,
                        [type]: isUndNullEmpNew({ data: value, subMethod: currentMethod, })?.result || isNaN(value) ? 1 : parseInt(value),
                    }));
                    break;
                case 'moduleId':
                    setModuleEvents(events.filter(({ moduleId, }) => moduleId === value));
                    setPrompt(prev => ({ ...prev, [type]: value, eventId: '', message: '' }));
                    await setMessageType({ moduleId: value, eventId: '', subMethod: currentMethod });
                    break;
                case 'eventId':
                    setPrompt(prev => ({ ...prev, [type]: value, message: '' }));
                    await setMessageType({ moduleId: prompt.moduleId, eventId: value, subMethod: currentMethod });
                    break;
                case 'message':
                    setPrompt(prev => ({ ...prev, [type]: value }));
                    if (textAreasShow.textAreaOne && !textAreasShow.textAreaTwo) {
                        setCharactersRemaining(
                            charactersRemainingGet(
                                $(`#${mercadoLibre?.objects?.html?.bots?.messageHideInnerTextId}`).val(),
                                mercadoLibre?.methods?.postSales?.seller?.maxLength,
                                `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                                'Message - PostSales - setFormData'
                            )?.result
                        );
                    } else if (!textAreasShow.textAreaOne && textAreasShow.textAreaTwo) {
                        setCharactersRemaining(
                            charactersRemainingGet(
                                value,
                                mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength,
                                `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                                'Message - setFormData'
                            )?.result
                        );
                    }
                    break;
                case 'accounts':
                    setPrompt(prev => ({ ...prev, accounts: value }));
                    setFormData_.accounts = value;
                    break;
                default:
                    setPrompt(prev => ({ ...prev, [type]: value, accounts: value }));
                    break;
            }

            if (type === 'moduleId' || type === 'eventId') {
                await processSummerNote({ e: null, type: 0, value: '', subMethod: currentMethod });
                $(`#${textAreaAnswerId}`).val('');
                $(`#${mercadoLibre?.objects?.html?.bots?.messageHideId}`).val('');
                $(`#${mercadoLibre?.objects?.html?.bots?.messageHideId}`).trigger('click');
            }

            response.result = setFormData_;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }

        return response;
    }

    const setErrorDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors({
                name: '',
                order: '',
                event: '',
                module: '',
                message: '',
            });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            let users_ = [UserClass?.getClass()];
            let prompt_ = PromptClass?.getClass();
            let responseOne = getResponse({ type: 0 });

            setProcess(prev => ({ ...prev, showLoading: true }));

            response = await getPrompt({ id: id, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            prompt_ = response?.result?.prompt || {};

            response = await getUsersByAccountId({ e: null, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            users_ = response?.result || [];

            response = await processSummerNote({ e: null, type: 1, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            if (!isUndNullEmpNew({ data: prompt_?.message, subMethod: currentMethod, })?.result) {
                response = await processSummerNote({ e: null, type: 4, value: prompt_?.message, subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
            }

            response = await setMessageType({ moduleId: prompt_.moduleId, eventId: prompt_.eventId, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            if (!isUndNullEmpNew({ data: prompt_?.moduleId, subMethod: currentMethod, })?.result &&
                !isUndNullEmpNew({ data: prompt_?.eventId, subMethod: currentMethod, })?.result) {
                if (prompt_.moduleId === mercadoLibre?.process?.modules?.[0]?.id) {
                    if (prompt_.eventId === mercadoLibre?.process?.events?.[0]?.id ||
                        prompt_.eventId === mercadoLibre?.process?.events?.[1]?.id) {
                        setCharactersRemaining(
                            charactersRemainingGet(
                                prompt_.message,
                                mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength,
                                `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                                'getPromptByIdAsync - getData'
                            )?.result
                        );
                    }
                } else if (prompt_.moduleId === mercadoLibre?.process?.modules?.[1]?.id) {
                    if (prompt_.eventId === mercadoLibre?.process?.events?.[2]?.id) {
                        setCharactersRemaining(
                            charactersRemainingGet(
                                $(`#${mercadoLibre?.objects?.html?.bots?.messageHideInnerTextId}`).val(),
                                mercadoLibre?.methods?.postSales?.seller?.maxLength,
                                `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                                'getPromptByIdAsync - getData'
                            )?.result
                        );
                    }
                }
            }

            response = await processDualListBox({ e: null, type: 1, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            if (!isUndNullEmpNew({ data: prompt_, subMethod: currentMethod, })?.result &&
                !isUndNullNew({ data: prompt_?.accounts, subMethod: currentMethod, })?.result &&
                prompt_?.accounts?.length > 0) {
                let selectedList_ = users_.filter((detail) => { return prompt_.accounts.includes(detail?.userName) });
                for (const detail of selectedList_) {
                    responseOne = await processDualListBox({
                        e: null,
                        type: 3,
                        value: detail?.userName,
                        selected: true,
                        subMethod: currentMethod,
                    });

                    if (!responseOne?.isSuccess || responseOne?.isWarning) {
                        response = responseOne;
                        return
                    };
                }

                let noSelectedList_ = users_.filter((detail) => { return !prompt_.accounts.includes(detail?.userName) });
                for (const detail of noSelectedList_) {
                    responseOne = await processDualListBox({
                        e: null,
                        type: 3,
                        value: detail?.userName,
                        selected: false,
                        subMethod: currentMethod,
                    });

                    if (!responseOne?.isSuccess || responseOne?.isWarning) {
                        response = responseOne;
                        return
                    };
                }
            } else if (!isUndNullNew({ data: users_, subMethod: currentMethod, })?.result && users_.length > 0) {
                for (const detail of users_) {
                    responseOne = await processDualListBox({
                        e: null,
                        type: 3,
                        value: detail?.userName,
                        selected: false,
                        subMethod: currentMethod,
                    });

                    if (!responseOne?.isSuccess || responseOne?.isWarning) {
                        response = responseOne;
                        return
                    };
                }
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const setMessageType = async ({
        moduleId = '',
        eventId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setMessageType';
        let response = getResponse({ type: 0 });
        try {
            if (!isUndNullEmpNew({ data: moduleId, subMethod: currentMethod, })?.result &&
                !isUndNullEmpNew({ data: eventId, subMethod: currentMethod, })?.result) {
                if (moduleId === mercadoLibre?.process?.modules?.[0]?.id) {
                    if (eventId === mercadoLibre?.process?.events?.[0]?.id ||
                        eventId === mercadoLibre?.process?.events?.[1]?.id) {
                        setTextAreasShow({ textAreaOne: false, textAreaTwo: true });
                    }
                } else if (moduleId === mercadoLibre?.process?.modules?.[1]?.id) {
                    if (eventId === mercadoLibre?.process?.events?.[2]?.id) {
                        setTextAreasShow({ textAreaOne: true, textAreaTwo: false });
                    }
                }
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const showEmojis = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'showEmojis';
        let response = getResponse({ type: 0 });
        try {
            setBotEmojisShowModal(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }

        return response;
    }

    const goToBack = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'goToBack';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true, back: true }));
            await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
            window.location.href = urls?.ai;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, back: false, showLoading: false }));
            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName='bots' process='ai' processLevel1='' />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.artificialIntelligence?.[languageObj?.id]}</h4>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={urls?.ai}>{labels?.artificialIntelligence?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.edit?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>
                                <form onSubmit={(e) => editPrompt({ e: e, subMethod: 'form-onSubmit' })}>
                                    <div className={settings?.html?.cards?.default} style={{ borderRadius: '8px' }}>
                                        <LoadingSection alt='loadingSection'
                                            className='overlay dark text-white'
                                            height={20}
                                            hidden={!process?.showLoading}
                                            width={20}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        <div className='card-header bg-white border-0 pt-4 px-4'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.bots?.[languageObj?.id]}
                                                            style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                            src={images?.icons?.bot || settings?.images?.icons?.bot} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.artificialIntelligence?.[languageObj?.id]}</h5>
                                                    </div>
                                                </div>
                                                <div className='card-tools'>
                                                    <button type='button'
                                                        className='btn btn-tool'
                                                        data-card-widget='collapse'>
                                                        <i className={icons?.fasFa?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='card-body px-4 pb-0'>

                                            {/* Name Input */}
                                            <div className='row'>
                                                <div className='col-12 mb-3'>
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.name?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.spellCheck} position-absolute input-icon-left`} />
                                                            <input className='form-control border-0 shadow-sm form-input-icon'
                                                                title={labels?.name?.[languageObj?.id]}
                                                                type='text'
                                                                onChange={(e) => setFormData({ type: 'name', value: e?.target?.value, subMethod: 'inputName' })}
                                                                onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                                                placeholder={labels?.name?.[languageObj?.id]}
                                                                value={prompt?.name || ''} />
                                                        </div>
                                                        <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.name)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Module & Event Selects */}
                                            <div className='row'>
                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.module?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.listUl} position-absolute input-icon-left`} />
                                                            <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                                                value={prompt?.moduleId || ''}
                                                                onChange={(e) => setFormData({ type: 'moduleId', value: e?.target?.value, subMethod: 'selectModules' })}
                                                                onFocus={() => setErrors(prev => ({ ...prev, module: '' }))}
                                                                placeholder={labels?.module?.[languageObj?.id]}
                                                                title={labels?.module?.[languageObj?.id]}>
                                                                <option key='nothing' value=''>{messages?.selectMethod?.[languageObj?.id]}</option>
                                                                {modules.map((detail) => <option key={detail?.id} value={detail?.id}>{detail?.name?.[languageObj?.id]}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.module)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.event?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.listOl} position-absolute input-icon-left`} />
                                                            <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                                                value={prompt?.eventId || ''}
                                                                onChange={(e) => setFormData({ type: 'eventId', value: e?.target?.value, subMethod: 'selectEvents' })}
                                                                onFocus={() => setErrors(prev => ({ ...prev, event: '' }))}
                                                                placeholder={labels?.event?.[languageObj?.id]}
                                                                title={labels?.event?.[languageObj?.id]}>
                                                                <option key='nothing' value=''>{messages?.selectEvent?.[languageObj?.id]}</option>
                                                                {moduleEvents.map((detail) => <option key={detail?.id} value={detail?.id}>{detail?.name?.[languageObj?.id]}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.event)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Status & Order */}
                                            <div className='row align-items-center'>
                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group mb-0'>
                                                        <div className='icheck-primary d-inline'>
                                                            <input type='checkbox'
                                                                id={chkBoStatusId}
                                                                checked={prompt?.status || false}
                                                                onChange={(e) => setFormData({ type: 'status', value: e?.target?.checked, subMethod: 'chkStatus' })} />
                                                            <label htmlFor={chkBoStatusId} style={{ cursor: 'pointer' }}>
                                                                {labels?.enabled?.[languageObj?.id]}?
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group mb-0'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.order?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.sortNumericUpAlt} position-absolute input-icon-left`} />
                                                            <input className='form-control border-0 shadow-sm form-input-icon'
                                                                max={inputOrder.max}
                                                                min={inputOrder.min}
                                                                title={labels?.order?.[languageObj?.id]}
                                                                type='number'
                                                                onChange={(e) => setFormData({ type: 'order', value: e?.target?.value, subMethod: 'inputOrder' })}
                                                                onFocus={() => setErrors(prev => ({ ...prev, order: '' }))}
                                                                placeholder={labels?.order?.[languageObj?.id]}
                                                                value={prompt?.order} />
                                                        </div>
                                                        <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.order)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Get Context */}
                                            <div className='row align-items-center'>
                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group mb-0'>
                                                        <div className='icheck-primary d-inline'>
                                                            <input type='checkbox'
                                                                id={chkBoGetContextId}
                                                                checked={prompt?.getContext || false}
                                                                onChange={(e) => setFormData({ type: 'getContext', value: e?.target?.checked, subMethod: 'chkGetContext' })} />
                                                            <label htmlFor={chkBoGetContextId} style={{ cursor: 'pointer' }}>
                                                                {labels?.getContext?.[languageObj?.id]}?
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group mb-0'></div>
                                                </div>
                                            </div>

                                            {/* Message Section Header */}
                                            <div className='row mt-4 mb-2'>
                                                <div className='col-12 col-md-3'><h6 className='font-weight-bold text-dark'>{labels?.message?.[languageObj?.id]}</h6></div>
                                                <div className='col-12 col-md-9'><hr className='my-2' /></div>
                                            </div>

                                            {/* PostSales Textarea Flow */}
                                            <div hidden={!textAreasShow.textAreaOne && textAreasShow.textAreaTwo}>
                                                <div className='form-group text-right mb-2'>
                                                    <button className='btn btn-light border shadow-sm font-weight-bold text-secondary btn-sm'
                                                        onClick={(e) => showEmojis({ e, subMethod: 'btnEmojisShow' })}
                                                        data-title={labels?.emoji?.[languageObj?.id]}
                                                        type='button'>
                                                        <i className={icons?.fasFa?.grin} />
                                                    </button>
                                                </div>
                                                <div className='form-group'>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.edit} position-absolute input-icon-left`} style={{ top: '25px', transform: 'none' }} />
                                                        <textarea id={mercadoLibre?.objects?.html?.bots?.messageId}
                                                            hidden={!textAreasShow.textAreaOne}
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            style={{ height: 'auto', paddingTop: '15px' }}
                                                            maxLength={mercadoLibre?.methods?.postSales?.seller?.maxLength}
                                                            onClick={() => setErrors(prev => ({ ...prev, message: '' }))}
                                                            placeholder={labels?.message?.[languageObj?.id]} />
                                                    </div>
                                                    <div className='form-text text-muted small mt-1'>{HtmlParser(charactersRemaining)}</div>
                                                    <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.message)}</div>
                                                </div>
                                                <div className='text-muted small' style={{ fontSize: '13px' }}>
                                                    <dl className='row'>
                                                        <dt className='col-md-4'>[greeting]</dt>
                                                        <dd className='col-md-8'>{messages?.displaysTheGreetingAccordingToTheTime?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>\t</dt>
                                                        <dd className='col-md-8'>{labels?.tab?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>\n</dt>
                                                        <dd className='col-md-8'>{labels?.lineReturn?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.item?.title}</dt>
                                                        <dd className='col-md-8'>{labels?.item?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.item?.quantity}</dt>
                                                        <dd className='col-md-8'>{labels?.quantity?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.item?.price}</dt>
                                                        <dd className='col-md-8'>{labels?.price?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.item?.priceOC}</dt>
                                                        <dd className='col-md-8'>{labels?.priceOtherCurrency?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.order?.number}</dt>
                                                        <dd className='col-md-8'>{labels?.order?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.order?.dateTime}</dt>
                                                        <dd className='col-md-8'>{labels?.dateTime?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.order?.date}</dt>
                                                        <dd className='col-md-8'>{labels?.date?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.order?.time}</dt>
                                                        <dd className='col-md-8'>{labels?.time?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.buyer?.fullName}</dt>
                                                        <dd className='col-md-8'>{labels?.fullName?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.buyer?.nickName}</dt>
                                                        <dd className='col-md-8'>{labels?.name?.[languageObj?.id]}.</dd>
                                                    </dl>
                                                </div>
                                                <div className='form-group'>
                                                    <textarea id={mercadoLibre?.objects?.html?.bots?.messageHideId}
                                                        className='form-control border-0 shadow-sm form-input-icon'
                                                        hidden={true}
                                                        maxLength={mercadoLibre?.methods?.postSales?.seller?.maxLength}
                                                        title={labels?.message?.[languageObj?.id]}
                                                        onClick={(e) => setFormData({ e: e, type: 'message', value: e?.target?.value, subMethod: 'textAreaMessage' })}
                                                        onFocus={() => setErrors(prev => ({ ...prev, message: '' }))}
                                                        placeholder={labels?.message?.[languageObj?.id]}
                                                        rows={rowsLength} />
                                                </div>
                                                <div className='form-group'>
                                                    <textarea id={mercadoLibre?.objects?.html?.bots?.messageHideInnerTextId}
                                                        className='form-control border-0 shadow-sm form-input-icon'
                                                        hidden={true}
                                                        maxLength={mercadoLibre?.methods?.postSales?.seller?.maxLength}
                                                        title={labels?.message?.[languageObj?.id]}
                                                        placeholder={labels?.message?.[languageObj?.id]}
                                                        rows={rowsLength} />
                                                </div>
                                            </div>

                                            {/* QuestionsAnswers Textarea Flow */}
                                            <div hidden={textAreasShow.textAreaOne && !textAreasShow.textAreaTwo}>
                                                <div className='form-group'>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.edit} position-absolute input-icon-left`} style={{ top: '25px', transform: 'none' }} />
                                                        <textarea id={textAreaAnswerId}
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            style={{ height: 'auto', paddingTop: '15px' }}
                                                            hidden={!textAreasShow.textAreaTwo}
                                                            maxLength={mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength}
                                                            title={labels?.message?.[languageObj?.id]}
                                                            onChange={(e) => setFormData({ e: e, type: 'message', value: e?.target?.value, subMethod: 'textAreaMessage' })}
                                                            onFocus={() => setErrors(prev => ({ ...prev, message: '' }))}
                                                            placeholder={labels?.message?.[languageObj?.id]}
                                                            rows={rowsLength}
                                                            value={prompt?.message || ''} />
                                                    </div>
                                                    <div className='form-text text-muted small mt-1'>{HtmlParser(charactersRemaining)}</div>
                                                    <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.message)}</div>
                                                    <div className='text-muted small mt-2' style={{ fontSize: '13px' }}>
                                                        <dl className='row'>
                                                            <dt className='col-md-4'>[greeting]</dt>
                                                            <dd className='col-md-8'>{messages?.displaysTheGreetingAccordingToTheTime?.[languageObj?.id]}.</dd>
                                                            <dt className='col-md-4'>[buyerName]</dt>
                                                            <dd className='col-md-8'>{messages?.displaysTheBuyerName?.[languageObj?.id]}.</dd>
                                                        </dl>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Accounts Section Header */}
                                            <div className='row mt-4 mb-2'>
                                                <div className='col-12 col-md-3'><h6 className='font-weight-bold text-dark'>{labels?.accounts?.[languageObj?.id]}</h6></div>
                                                <div className='col-12 col-md-9'><hr className='my-2' /></div>
                                            </div>

                                            {/* Dual Listbox Select */}
                                            <div className='form-group mb-4'>
                                                <select id={mercadoLibre?.objects?.html?.bots?.duallistboxId}
                                                    className='duallistbox' multiple='multiple'>
                                                </select>
                                            </div>

                                            {/* Summernote hidden triggers */}
                                            <div className='form-group' hidden={true}>
                                                <button className='btn btn-sm btn-outline-primary' id={summerNote?.btnEvents?.setCode} title='set data' type='button'><i className={icons?.fasFa?.edit}></i></button>
                                                <button className='btn btn-sm btn-outline-secondary mx-1' id={summerNote?.btnEvents?.isEmpty} title='is empty?' type='button'><i className={icons?.farFa?.squareMinus}></i></button>
                                                <button className='btn btn-sm btn-outline-success' id={summerNote?.btnEvents?.code} title='get data' type='button'><i className={icons?.faFa?.check}></i></button>
                                                <button className='btn btn-sm btn-outline-info mx-1' id={summerNote?.btnEvents?.reset} title='clear' type='button'><i className={icons?.farFa?.file}></i></button>
                                                <button className='btn btn-sm btn-outline-info' id={summerNote?.btnEvents?.init} title='initialize' type='button'><i className={icons?.fasFa?.eye}></i></button>
                                                <button className='btn btn-sm btn-outline-warning mx-1' id={summerNote?.btnEvents?.destroy} title='destroy' type='button'><i className={icons?.fasFa?.eyeSlash}></i></button>
                                            </div>

                                            {/* Duallistbox hidden triggers */}
                                            <div className='form-group' hidden={true}>
                                                <button className='btn btn-sm btn-outline-success mx-1' id={dualListBox?.btnEvents?.setValue} title='set data' type='button'><i className={icons?.fasFa?.plusCircle}></i></button>
                                                <button className='btn btn-sm btn-outline-primary' id={dualListBox?.btnEvents?.refresh} title='refresh' type='button'><i className={icons?.fasFa?.edit}></i></button>
                                                <button className='btn btn-sm btn-outline-info mx-1' id={dualListBox?.btnEvents?.init} title='initialize' type='button'><i className={icons?.fasFa?.eye}></i></button>
                                                <button className='btn btn-sm btn-outline-warning' id={dualListBox?.btnEvents?.destroy} title='destroy' type='button'><i className={icons?.fasFa?.eyeSlash}></i></button>
                                            </div>
                                        </div>

                                        {/* Card Footer - 2026 Premium Actions bar */}
                                        <div className='card-footer border-0 bg-white px-4 pb-4 d-flex flex-wrap justify-content-end align-items-center' style={{ gap: '8px' }}>
                                            <button className='btn btn-primary shadow-sm font-weight-bold px-4'
                                                disabled={process?.showLoading}
                                                data-title={labels?.save?.[languageObj?.id]}
                                                type='submit'>
                                                {!process?.save ? (
                                                    <i className={`${icons?.fasFa?.save} mr-2`} />
                                                ) : (
                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                )} {labels?.save?.[languageObj?.id]}
                                            </button>
                                            <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                                                disabled={process?.showLoading}
                                                data-title={labels?.back?.[languageObj?.id]}
                                                onClick={(e) => { goToBack({ e: e, subMethod: 'btnGoToBack' }) }}
                                                type='button'>
                                                {!process?.back ? (
                                                    <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-2`} />
                                                ) : (
                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                )} {labels?.back?.[languageObj?.id]}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {botEmojisShowModal && (
                        <BotEmojis processValues={{
                            showModal: botEmojisShowModal,
                            setShowModal: setBotEmojisShowModal,
                        }}
                            languageObj={languageObj} />
                    )}
                </section>
                {/* /.content */}
            </div>
        </div>
    )
}